module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Barry-S2.dcb1dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Barry-S2.jpg
// module id = gP1p
// module chunks = 0